import React from 'react'
import { useTranslation } from 'react-i18next'
import LocalizedLink from '../../components/LocalizedLink/LocalizedLink'
import Services from '../../api/Services'
import Events from '../../api/events'
import { Image } from '@imagekit/react'

const EventSidebar = (props) => {

    const { t } = useTranslation(['events', 'services'])

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="col col-lg-4 col-12">
            <div className="blog-sidebar">
                <div className="widget search-widget">
                    <form onSubmit={SubmitHandler}>
                        <div>
                            <input type="text" className="form-control" placeholder={t('events:single.searchPlaceholder')} />
                            <button type="submit"><i className="ti-search"></i></button>
                        </div>
                    </form>
                </div>
                <div className="widget recent-post-widget">
                    <h3>{t('events:single.relatedPosts')}</h3>
                    <div className="posts">
                        {Events.slice(0, 3).map((event, eitem) => (
                            <div className="post" key={eitem}>
                                <div className="img-holder">
                                    <Image src={event.eImg} alt="" transformation={[
                                        {
                                            width: "700",
                                            height: "560",
                                            crop: "maintain_ratio",
                                            focus: "auto",
                                        },
                                    ]} />
                                </div>
                                <div className="details">
                                    <h4><LocalizedLink onClick={ClickHandler} to={`/event-single/${event.slug}`}>{t(`events:items.${event.slug}.title`)}</LocalizedLink></h4>
                                    <span className="date">{t(`events:items.${event.slug}.date`)} @ {event.time}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="widget recent-post-widget">
                    <h3>{t('events:single.services')}</h3>
                    <div className="posts">
                        {Services.slice(0, 6).map((service, pitem) => (
                            <div className="post" key={pitem}>
                                <div className="img-holder">
                                    <Image src={service.sImg} alt={t(`services:${service.slug}.title`)} transformation={[
                                        {
                                            width: "700",
                                            height: "560",
                                            crop: "maintain_ratio",
                                            focus: "auto",
                                        },
                                    ]} />
                                </div>
                                <div className="details">
                                    <h4><LocalizedLink onClick={ClickHandler} to={`/service-single/${service.slug}`}>{t(`services:${service.slug}.title`)}</LocalizedLink></h4>
                                    <span className="f-small">{t(`services:${service.slug}.shortDescription`)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EventSidebar;
